import { render } from "./PaymentMethodType.vue?vue&type=template&id=14778268&scoped=true"
import script from "./PaymentMethodType.vue?vue&type=script&lang=js"
export * from "./PaymentMethodType.vue?vue&type=script&lang=js"

import "./PaymentMethodType.vue?vue&type=style&index=0&id=14778268&lang=scss&scoped=true"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14778268"]])

export default __exports__